// extracted by mini-css-extract-plugin
export var active = "_6l-a";
export var activeIndicator = "_6l-9";
export var disabled = "_6l-b";
export var fullWidth = "_6l-2";
export var lg = "_6l-7";
export var md = "_6l-6";
export var redoButtonTabGroup = "_6l-0";
export var sm = "_6l-5";
export var tabButton = "_6l-4";
export var tabButtonsContainer = "_6l-1";
export var themeDestructive = "_6l-d";
export var themeNormal = "_6l-c";
export var themeSuccess = "_6l-e";
export var xl = "_6l-8";
export var xs = "_6l-3";